export const sharedStyles = `
  min-width: 250px;
  width: 100%;
  margin: 10px;
  box-sizing: border-box;
`;
